import GenericPayment from './GenericPayment';

export default GenericPayment;
